// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"63b08122","732":"db852d7a","826":"01535a9a"}[chunkId] + ".chunk.js";
};